/**
 * Maintenance Modal
 * If the site is down for maintenace
 */
import React from "react"
import PropTypes from "prop-types"
import Modal from "components/Modal"
import Text from "components/Text"
import axios from "axios"

export class Maintenance extends React.Component {
  state = {
    isModalOpen: false,
    title: "",
    messageHTML: "",
  }

  async componentDidMount() {
    const result = await axios.get(
      `https://rarewebsite.s3.eu-west-1.amazonaws.com/a4f2c5f4-3c9b-40a0-9073-37a1b420dcbf.txt`
    )
    if (result.data) {
      const tokens = result.data.split("\n")
      if (tokens[0].indexOf(`:::${process.env.REACT_APP_API_ENV}:::`) > -1) {
        this.setState({
          isModalOpen: true,
          title: tokens.length > 1 ? tokens[1] : `DOWN FOR MAINTENANCE`,
          messageHTML:
            tokens.length > 2
              ? tokens[2]
              : `<p>This website is currently undergoing essential maintenance, please try again later.</p><p>We apologise for any inconvenience caused. Please come back later.</p><p>Thanks,</p><p>Rare</p>`,
        })
      }
    }
  }

  render() {
    const { align = "center" } = this.props
    const { title, messageHTML } = this.state
    return (
      <Modal open={this.state.isModalOpen} title={title} align={align}>
        <Text variant={"text"}>
          <div dangerouslySetInnerHTML={{ __html: messageHTML }} />
        </Text>
      </Modal>
    )
  }
}

Maintenance.propTypes = {
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.bool,
}
export default Maintenance
